import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/About.css";
import AboutImage from "../../../Images/Group 1618874841.svg";
import { API_URL } from "../../../config/api";

const About = () => {
  const [activeCTA, setActiveCTA] = useState("student");
  const [frontPageVideoURL, setFrontPageVideoURL] = useState(null);
  const [videoLoading, setVideoLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_URL}/azure-upload/home-page-video`)
      .then((res) => {
        if (!res.ok) return null;
        return res.json();
      })
      .then((data) => {
        if (data?.video_url) {
          setFrontPageVideoURL(data.video_url);
        }
      })
      .catch(() => {})
      .finally(() => setVideoLoading(false));
  }, []);

  return (
    <section className="about-container">
      <div className="about-wrapper">
        {/* Left Content */}
        <div className="about-left">
          <div className="platform-label">Medical Learning Platform</div>

          <h1 className="main-heading">
            The Right Place to <br />
            Build the <span className="highlight">Right Career</span>
          </h1>

          <p className="description">
            SkillMD helps medical students and professionals learn smarter,
            grow faster, and achieve their career goals. Gain real-world skills
            through expert-led courses, hands-on training, and interactive learning.
          </p>
        </div>

        {/* Right Content */}
        <div className="about-right">
          {videoLoading ? (
            <div className="about-video-skeleton" />
          ) : frontPageVideoURL ? (
            <video
              src={frontPageVideoURL}
              className="about-video"
              controls
              playsInline
            />
          ) : (
            <img
              src={AboutImage}
              alt="About Us Illustration"
              className="about-image"
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default About;